/* PFT-Profi Ersatzteil-Explorer
   Liest die Maschinendaten aus window.PFT_ET[<key>], zeigt Zeichnung, Positionen und Teileliste
   und holt Preis, Verfügbarkeit und Varianten-ID live aus Shopify (SKU = PFT-Artikelnummer). */
(function () {
  'use strict';

  var CART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6.2"/><circle cx="9" cy="20" r="1.2"/><circle cx="17" cy="20" r="1.2"/></svg>';
  var VAT = 1.19;
  var cache = {};
  var queue = [];
  var running = 0;
  var MAX_PARALLEL = 4;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function isLiveShop() {
    return location.protocol.indexOf('http') === 0 && !!(window.Shopify && window.Shopify.shop);
  }

  /* ---------- Shopify-Abfrage per Artikelnummer ---------- */
  function fetchJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }
  function doLookup(art) {
    var q = '/search/suggest.json?q=' + encodeURIComponent(art) +
      '&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.sku,title';
    return fetchJSON(q).then(function (res) {
      var prods = (((res || {}).resources || {}).results || {}).products || [];
      var i = 0;
      function next() {
        if (i >= prods.length) return null;
        var p = prods[i++];
        return fetchJSON('/products/' + p.handle + '.js').then(function (full) {
          var vs = (full.variants || []).filter(function (v) { return String(v.sku || '').trim() === art; });
          if (!vs.length) return next();
          var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
          return {
            id: v.id,
            price: v.price,
            available: !!v.available,
            url: full.url + '?variant=' + v.id,
            title: full.title + (vs.length === 1 && full.variants.length > 1 && v.title !== 'Default Title' ? ' – ' + v.title : '')
          };
        }).catch(function () { return next(); });
      }
      return next();
    });
  }
  function lookup(art) {
    if (!art) return Promise.resolve(null);
    if (cache[art]) return cache[art];
    try {
      var stored = sessionStorage.getItem('pet:' + art);
      if (stored) { cache[art] = Promise.resolve(JSON.parse(stored)); return cache[art]; }
    } catch (e) {}
    if (!isLiveShop()) { cache[art] = Promise.resolve({ demo: true }); return cache[art]; }
    cache[art] = new Promise(function (resolve) {
      queue.push(function () {
        return doLookup(art).then(function (r) {
          try { sessionStorage.setItem('pet:' + art, JSON.stringify(r)); } catch (e) {}
          resolve(r);
        }).catch(function () { resolve(null); });
      });
      pump();
    });
    return cache[art];
  }
  function pump() {
    while (running < MAX_PARALLEL && queue.length) {
      running++;
      queue.shift()().then(function () { running--; pump(); });
    }
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Fehler');
        return j;
      });
    }).then(function (j) {
      // UpCart und gängige Theme-Warenkörbe aktualisieren / öffnen
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      try { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); } catch (e) {}
      ['cart:refresh', 'theme:cart:refresh', 'cart:build'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      return j;
    });
  }
  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pet-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4000);
  }

  /* ---------- Darstellung ---------- */
  function priceHTML(r) {
    if (!r) return '<span class="pet-load">Auf Anfrage</span>';
    if (r.demo) return '<span class="pet-load">Live-Preis im Shop</span>';
    return '<span class="pet-p">' + money(r.price) + '<small>' + money(Math.round(r.price / VAT)) + ' netto</small></span>';
  }
  function stockHTML(r) {
    if (!r || r.demo) return '';
    return r.available ? '<span class="pet-stock ok">Sofort lieferbar</span>' : '<span class="pet-stock no">Derzeit nicht vorrätig</span>';
  }
  function requestLink(item, machine) {
    var subj = 'Anfrage Ersatzteil ' + item.a + ' – ' + item.n;
    var body = 'Maschine: ' + machine + '%0D%0AArt.-Nr.: ' + item.a + '%0D%0ABezeichnung: ' + item.n + '%0D%0AMenge: ';
    return 'mailto:shop@pft-profi.de?subject=' + encodeURIComponent(subj) + '&body=' + body;
  }

  function Explorer(root, data, base) {
    this.root = root;
    this.data = data;
    this.base = base || '';
    this.machine = data.machine + ' (' + data.variant + ')';
    this.gi = 0;
    this.render();
    var startNr = parseInt((location.hash.match(/gruppe-(\d+)/) || [])[1], 10);
    var idx = data.groups.findIndex(function (g) { return g.nr === startNr; });
    this.show(idx > -1 ? idx : 0);
  }

  Explorer.prototype.render = function () {
    var d = this.data, self = this;
    var nav = d.groups.map(function (g, i) {
      return '<button type="button" data-g="' + i + '"><span>' + g.nr + '</span>' + esc(g.title) + '</button>';
    }).join('');
    var opts = d.groups.map(function (g, i) {
      return '<option value="' + i + '">' + g.nr + '. ' + esc(g.title) + '</option>';
    }).join('');
    this.root.innerHTML =
      '<div class="pet-head">' +
        '<div><h2>' + esc(d.machine) + ' – Ersatzteile</h2><p>Variante ' + esc(d.variant) + ' · Positionen anklicken oder Teil suchen</p></div>' +
        '<div class="pet-search"><input type="search" placeholder="Teil oder Artikelnummer suchen" aria-label="Ersatzteil suchen" autocomplete="off"><div class="pet-results" role="listbox"></div></div>' +
      '</div>' +
      '<select class="pet-select" aria-label="Baugruppe wählen">' + opts + '</select>' +
      '<div class="pet-body">' +
        '<nav class="pet-nav" aria-label="Baugruppen">' + nav + '</nav>' +
        '<div class="pet-stage"><h3></h3><figure class="pet-fig"><img alt="" decoding="async"><div class="pet-card" hidden></div></figure>' +
          '<p class="pet-hint">Tipp: Fahr mit der Maus über eine Nummer oder tippe sie an.</p></div>' +
        '<div class="pet-list"><div class="pet-list-head"></div><div class="pet-rows"></div></div>' +
      '</div>' +
      '<p class="pet-foot">Zeichnungen und Artikelnummern: ' + esc(d.source) + '. Preise inkl. 19 % MwSt.</p>';

    this.fig = this.root.querySelector('.pet-fig');
    this.img = this.fig.querySelector('img');
    this.card = this.fig.querySelector('.pet-card');
    this.rows = this.root.querySelector('.pet-rows');

    this.root.querySelector('.pet-nav').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (b) self.show(+b.getAttribute('data-g'));
    });
    this.root.querySelector('.pet-select').addEventListener('change', function (e) { self.show(+e.target.value); });

    // Hotspots
    this.fig.addEventListener('mouseover', function (e) {
      var h = e.target.closest('.pet-hs'); if (h) self.hl(h.getAttribute('data-k'), true);
    });
    this.fig.addEventListener('mouseout', function (e) {
      var h = e.target.closest('.pet-hs'); if (h) self.hl(h.getAttribute('data-k'), false);
    });
    this.fig.addEventListener('click', function (e) {
      if (e.target.closest('.pet-card')) return;
      var h = e.target.closest('.pet-hs');
      if (h) self.open(h.getAttribute('data-k'), h); else self.close();
    });

    // Karte
    this.card.addEventListener('click', function (e) {
      if (e.target.closest('.pet-card-close')) { self.close(); return; }
      var b = e.target.closest('[data-add]');
      if (b) {
        var q = parseInt(self.card.querySelector('.pet-qty').value, 10) || 1;
        self.add(b, +b.getAttribute('data-add'), q);
      }
    });

    // Liste
    this.rows.addEventListener('mouseover', function (e) {
      var r = e.target.closest('.pet-row'); if (r) self.hl(r.getAttribute('data-k'), true);
    });
    this.rows.addEventListener('mouseout', function (e) {
      var r = e.target.closest('.pet-row'); if (r) self.hl(r.getAttribute('data-k'), false);
    });
    this.rows.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (add) { e.stopPropagation(); self.add(add, +add.getAttribute('data-add'), 1); return; }
      var r = e.target.closest('.pet-row'); if (!r) return;
      var k = r.getAttribute('data-k');
      var h = self.fig.querySelector('.pet-hs[data-k="' + k + '"]');
      if (h) {
        if (window.innerWidth <= 1100) self.fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
        self.open(k, h);
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
    window.addEventListener('resize', function () { self.close(); });

    this.initSearch();
  };

  Explorer.prototype.key = function (g, sub, pos) { return (g.multi && sub ? sub + '|' : '') + pos; };

  Explorer.prototype.show = function (i) {
    var self = this, g = this.data.groups[i];
    this.gi = i; this.g = g; this.close();
    this.root.querySelectorAll('.pet-nav button').forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    this.root.querySelector('.pet-select').value = i;
    this.root.querySelector('.pet-stage h3').textContent = g.nr + '. ' + g.title;
    this.img.src = this.base + g.img;
    this.img.width = g.w; this.img.height = g.h;
    this.img.alt = 'Explosionszeichnung ' + this.data.machine + ': ' + g.title;

    // Hotspots
    this.fig.querySelectorAll('.pet-hs').forEach(function (n) { n.remove(); });
    var frag = document.createDocumentFragment();
    g.hot.forEach(function (h) {
      var k = self.key(g, h.s, h.t);
      var item = self.item(k);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pet-hs' + (h.t.slice(-1) === '.' ? ' is-sub' : '');
      b.style.left = h.x + '%'; b.style.top = h.y + '%';
      b.textContent = h.t;
      b.setAttribute('data-k', k);
      b.setAttribute('aria-label', 'Position ' + h.t + (item ? ': ' + item.n : ''));
      frag.appendChild(b);
    });
    this.fig.insertBefore(frag, this.card);

    // Liste
    var html = '', subTitle = null, count = 0;
    g.items.forEach(function (it) {
      var k = self.key(g, it.s, it.p);
      if (it.p.slice(-1) === '.') {
        html += '<div class="pet-sub">' + esc(it.p) + ' ' + esc(it.n) + (it.a ? ' <small>· ' + it.a + '</small>' : '') + '</div>';
        if (!it.a) return;
      }
      if (it.a) count++;
      html += '<div class="pet-row" data-k="' + esc(k) + '" data-art="' + esc(it.a || '') + '">' +
        '<span class="pet-row-pos">' + esc(it.p) + '</span>' +
        '<span class="pet-row-name">' + esc(it.n) + (it.a ? '<small>Art.-Nr. ' + it.a + '</small>' : '') + '</span>' +
        '<span class="pet-row-price"><span class="pet-load">…</span></span>' +
        '<span class="pet-row-act"></span></div>';
    });
    this.rows.innerHTML = html;
    this.rows.scrollTop = 0;
    this.root.querySelector('.pet-list-head').textContent = count + ' Teile in dieser Baugruppe';
    if (history.replaceState) history.replaceState(null, '', '#gruppe-' + g.nr);
    this.loadPrices();
  };

  Explorer.prototype.item = function (k) {
    var g = this.g, self = this;
    return g.items.filter(function (it) { return self.key(g, it.s, it.p) === k; })[0];
  };

  Explorer.prototype.loadPrices = function () {
    var self = this;
    var rows = this.rows.querySelectorAll('.pet-row');
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); self.fillRow(en.target); } });
    }, { root: null, rootMargin: '200px' }) : null;
    rows.forEach(function (r) { io ? io.observe(r) : self.fillRow(r); });
  };

  Explorer.prototype.fillRow = function (row) {
    var art = row.getAttribute('data-art'), self = this;
    var pc = row.querySelector('.pet-row-price'), ac = row.querySelector('.pet-row-act');
    if (!art) { pc.innerHTML = ''; return; }
    lookup(art).then(function (r) {
      pc.innerHTML = priceHTML(r);
      if (r && !r.demo) {
        ac.innerHTML = '<button type="button" class="pet-add" data-add="' + r.id + '" aria-label="In den Warenkorb"' + (r.available ? '' : ' disabled title="Derzeit nicht vorrätig"') + '>' + CART_SVG + '</button>';
      } else {
        var it = self.g.items.filter(function (x) { return x.a === art; })[0];
        ac.innerHTML = r && r.demo
          ? '<button type="button" class="pet-add" disabled aria-label="In den Warenkorb">' + CART_SVG + '</button>'
          : '<a class="pet-add" href="' + requestLink(it, self.machine) + '" aria-label="Teil anfragen" title="Teil anfragen"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="m3 7 9 6 9-6"/></svg></a>';
      }
    });
  };

  Explorer.prototype.hl = function (k, on) {
    this.fig.querySelectorAll('.pet-hs[data-k="' + k + '"]').forEach(function (h) { h.classList.toggle('is-hl', on); });
    this.rows.querySelectorAll('.pet-row[data-k="' + k + '"]').forEach(function (r) { r.classList.toggle('is-hl', on); });
  };

  Explorer.prototype.open = function (k, anchor) {
    var self = this, it = this.item(k);
    if (!it) return;
    this.close(true);
    this.fig.querySelectorAll('.pet-hs[data-k="' + k + '"]').forEach(function (h) { h.classList.add('is-active'); });
    var row = this.rows.querySelector('.pet-row[data-k="' + k + '"]');
    if (row) {
      row.classList.add('is-active');
      if (window.innerWidth > 1100) {
        var top = row.offsetTop - this.rows.clientHeight / 2 + row.clientHeight / 2;
        this.rows.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }
    var c = this.card;
    c.innerHTML =
      '<button type="button" class="pet-card-close" aria-label="Schließen">×</button>' +
      '<div class="pet-pos">Position ' + esc(it.p) + '</div>' +
      '<div class="pet-name">' + esc(it.n) + '</div>' +
      (it.a ? '<div class="pet-art">Art.-Nr. ' + it.a + '</div>' : '<div class="pet-art">Baugruppe, Einzelteile siehe Liste</div>') +
      '<div class="pet-price">' + (it.a ? '<span class="pet-load">Preis wird geladen …</span>' : '') + '</div>' +
      '<div class="pet-actions"></div>';
    c.hidden = false;
    this.place(anchor);
    if (!it.a) return;
    lookup(it.a).then(function (r) {
      if (c.hidden) return;
      c.querySelector('.pet-price').innerHTML = priceHTML(r) + ' ' + stockHTML(r);
      var act = c.querySelector('.pet-actions');
      if (r && !r.demo) {
        act.innerHTML = '<div class="pet-buy"><input class="pet-qty" type="number" min="1" value="1" aria-label="Menge">' +
          '<button type="button" class="pet-btn" data-add="' + r.id + '"' + (r.available ? '' : ' disabled') + '>In den Warenkorb</button></div>' +
          '<a class="pet-link" href="' + r.url + '">Zum Produkt</a>';
      } else if (r && r.demo) {
        act.innerHTML = '<div class="pet-buy"><input class="pet-qty" type="number" min="1" value="1" aria-label="Menge"><button type="button" class="pet-btn" disabled>In den Warenkorb</button></div>' +
          '<span class="pet-link" style="color:#7a7f86">Vorschau: Preis und Warenkorb funktionieren im Shop.</span>';
      } else {
        act.innerHTML = '<div class="pet-buy"><a class="pet-btn pet-btn-line" href="' + requestLink(it, self.machine) + '">Teil anfragen</a></div>';
      }
      self.place(anchor);
    });
  };

  Explorer.prototype.place = function (anchor) {
    var c = this.card;
    if (window.innerWidth <= 760) return; // Bottom-Sheet per CSS
    var fw = this.fig.clientWidth, fh = this.fig.clientHeight;
    var ax = anchor.offsetLeft, ay = anchor.offsetTop;
    var cw = c.offsetWidth, ch = c.offsetHeight;
    var left = ax + 18, top = ay - 20;
    if (left + cw > fw - 8) left = ax - cw - 18;
    if (left < 8) left = Math.max(8, Math.min(fw - cw - 8, ax - cw / 2));
    if (top + ch > fh - 8) top = fh - ch - 8;
    if (top < 8) top = 8;
    c.style.left = left + 'px'; c.style.top = top + 'px';
  };

  Explorer.prototype.close = function (keepCard) {
    if (!this.fig) return;
    this.fig.querySelectorAll('.pet-hs.is-active').forEach(function (h) { h.classList.remove('is-active'); });
    this.rows.querySelectorAll('.pet-row.is-active').forEach(function (r) { r.classList.remove('is-active'); });
    if (!keepCard) this.card.hidden = true;
  };

  Explorer.prototype.add = function (btn, id, qty) {
    if (!id || btn.disabled) return;
    var old = btn.innerHTML;
    btn.disabled = true;
    if (btn.classList.contains('pet-btn')) btn.textContent = 'Wird hinzugefügt …';
    addToCart(id, qty).then(function () {
      toast('Zum Warenkorb hinzugefügt <a href="/cart">Warenkorb ansehen</a>');
      if (btn.classList.contains('pet-btn')) btn.textContent = 'Hinzugefügt ✓';
      setTimeout(function () { btn.innerHTML = old; btn.disabled = false; }, 1800);
    }).catch(function (err) {
      toast('Konnte nicht hinzugefügt werden: ' + esc(err.message));
      btn.innerHTML = old; btn.disabled = false;
    });
  };

  Explorer.prototype.initSearch = function () {
    var self = this;
    var input = this.root.querySelector('.pet-search input');
    var box = this.root.querySelector('.pet-results');
    var all = [];
    this.data.groups.forEach(function (g, gi) {
      g.items.forEach(function (it) {
        if (it.a) all.push({ gi: gi, g: g, it: it, hay: (it.n + ' ' + it.a).toLowerCase() });
      });
    });
    function run() {
      var q = input.value.trim().toLowerCase();
      if (q.length < 2) { box.classList.remove('is-open'); return; }
      var parts = q.split(/\s+/);
      var hits = all.filter(function (x) { return parts.every(function (p) { return x.hay.indexOf(p) > -1; }); }).slice(0, 30);
      box.innerHTML = hits.length ? hits.map(function (x, i) {
        return '<button type="button" data-i="' + i + '">' + esc(x.it.n) + '<small>Art.-Nr. ' + x.it.a + ' · Gruppe ' + x.g.nr + ', Pos. ' + esc(x.it.p) + '</small></button>';
      }).join('') : '<div class="pet-empty">Kein Teil gefunden. Schreib uns gerne an shop@pft-profi.de.</div>';
      box._hits = hits;
      box.classList.add('is-open');
    }
    input.addEventListener('input', run);
    input.addEventListener('focus', run);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var x = box._hits[+b.getAttribute('data-i')];
      box.classList.remove('is-open');
      self.show(x.gi);
      var k = self.key(x.g, x.it.s, x.it.p);
      var h = self.fig.querySelector('.pet-hs[data-k="' + k + '"]');
      setTimeout(function () {
        self.fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (h) self.open(k, h);
      }, 60);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pet-search')) box.classList.remove('is-open');
    });
  };

  function start(el) {
    if (el._pet) return;
    el._pet = true;
    var src = el.getAttribute('data-src');
    if (src) {
      // Daten als JSON aus "Inhalte > Dateien"; Zeichnungen liegen im selben Ordner
      var clean = src.split('?')[0];
      var base = clean.slice(0, clean.lastIndexOf('/') + 1);
      fetch(src).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (data) {
        el._pet = new Explorer(el, data, base);
      }).catch(function () {
        el.innerHTML = '<p style="padding:24px 0;color:#7a7f86;">Ersatzteildaten nicht gefunden: ' + esc(clean.split('/').pop()) +
          '. Bitte prüfen, ob die Datei unter Inhalte &gt; Dateien hochgeladen ist.</p>';
      });
      return;
    }
    var data = (window.PFT_ET || {})[el.getAttribute('data-machine')];
    if (!data) { el.innerHTML = '<p>Ersatzteildaten nicht gefunden.</p>'; return; }
    el._pet = new Explorer(el, data, el.getAttribute('data-img-base') || '');
  }
  function init() {
    document.querySelectorAll('.pet[data-src], .pet[data-machine]').forEach(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
